import type { FC } from 'react'
import ProceedToCheckout from '../buttons/ProceedToCheckout'
import { useShoppingCartTotals } from '../hooks/useShoppingCartTotals'
import CryptoPriceTag from './CryptoPriceTag'

const Divider: FC = () => (
  <div className="flex items-center w-full space-x-4">
    <div className="h-px bg-gray-600 grow"></div>
    <div className="text-sm text-white/50">or</div>
    <div className="h-px bg-gray-600 grow"></div>
  </div>
)

const ShoppingCartPaymentSummary: FC = () => {
  const { total } = useShoppingCartTotals()

  return (
    <div className="flex flex-col w-full space-y-4">
      {!!total?.loot.length && total.price.totals && (
        <>
          <div className="h-12">
            <ProceedToCheckout />
          </div>
          <div>
            <div className="mb-2 text-sm text-white/50">Subtotal</div>
            <CryptoPriceTag
              data-cy-spec="shop-cart-crypto-price-tag-prps"
              layout="row-grow"
              symbol="PRPS"
              price={total.price.totals.totalPrps}
              priceValueClassNames="text-green-400"
              size="small"
            />
            <Divider />
            <CryptoPriceTag
              data-cy-spec="shop-cart-crypto-price-tag-dubi"
              layout="row-grow"
              symbol="DUBI"
              price={total.price.totals.totalDubi}
              priceValueClassNames="text-green-400"
              size="small"
            />
          </div>
        </>
      )}
    </div>
  )
}

export default ShoppingCartPaymentSummary
